export default function Locations() {
  return (
    <div style={{ height: "100vh" }}>
      <iframe
        title="hospital locations"
        src="https://www.google.com/maps/d/u/0/embed?mid=1suxlgcf_gPwoe6rxXXozmlSntdgTJzyj"
        width="100%"
        height="85%"
      ></iframe>
    </div>
  );
}
